class ProfilePictureController {
    constructor(userApiService) {
        this.userApiService = userApiService;
        this.photo = '';
        this.cancellationToken = {
            isCancelled: false
        };
    }

    $onChanges(changes) {
        if (!changes.hasOwnProperty('isSmall') || changes.isSmall.isFirstChange()) {
            this.photo = null;
            if (changes.userId) {
                this.savedUserId = changes.userId.currentValue;
                this.setPhoto();
            } else if (changes.isExternal) {
                this.setPhoto();
            }

            this.setInitials();
        }
    }

    setPhoto() {
        if (this.savedUserId) {
            const userId = this.savedUserId;
            this.userApiService.getProfilePhotoForUserId(userId, this.cancellationToken).then(
                (result) => {
                    if (this.savedUserId === userId) {
                        this.photo = result.data;
                    }
                },
                () => {
                    if (this.savedUserId === userId) {
                        this.photo = null;
                    }
                }
            );
        } else {
            this.photo = null;
        }
    }

    setInitials() {
        if (!this.name || this.name.trim() === '') {
            return;
        }

        let names = this.name.replace(/\s+/g, ' ').trim().split(' ');

        let initials = names[0][0];
        if (names.length > 1) {
            initials += names[names.length - 1][0];
        }

        this.initials = initials.toUpperCase();
    }

    $onDestroy() {
        this.cancellationToken.isCancelled = true;
    }
}

ProfilePictureController.$inject = ['userApiService'];

export default ProfilePictureController;
